module.exports = __webpack_public_path__ + "img/pointer_03.a95d2568.png";